import sum from './sum'

const items = [
  {
    name: 'childproofingSupplies',
    label: 'Childproofing supplies',
    description: 'Door knobs, corner guards, safety locks, etc. Childproofing supplies typically range anywhere from $50-$200.',
    enabled: true,
    value: 100,
  },
  {
    name: 'babySafetyGates',
    label: 'Baby safety gates',
    description: "Safety gates typically range anywhere from $20 - $75 each. It's common to have 1-3 baby gates per household.",
    enabled: true,
    value: 75,
  },
]


export default {
  name: 'home',
  label: 'Home',
  enabled: false,
  value: sum(items),
  on: false,
  items,
}
